module.exports = __webpack_public_path__ + "static/android-033513771ee3bdbf7d9596179b2c9545.png";